export default __webpack_public_path__ + "static/media/392.3c492c6d.png";